module.exports = __webpack_public_path__ + "img/group.d03ff09a.svg";